import { createSelector } from 'reselect'
// import { List } from 'immutable'

const standardPriceSelector = state => state.get('standardPrice')

export const getIsFetching = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceCreate.isFetching
    || standardPrice.standardPriceEdit.isFetching
    || standardPrice.standardPriceGet.isFetching
    || standardPrice.standardPriceDeactivate.isFetching
    || standardPrice.standardPriceList.isFetching
    || standardPrice.standardPriceExport.isFetching
  }
)
export const getCreateStandardPriceData = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceCreate
  }
)
export const getEditStandardPriceData = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceEdit
  }
)
export const getGetStandardPriceData = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceGet.standardPrice
  }
)
export const getDeactivateStandardPriceData = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceDeactivate
  }
)
export const getListStandardPrice = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceList.standardPrice || []
  }
)
export const getExportURL = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return standardPrice.standardPriceExport.url
  }
)
export const redirectStandardPrice = createSelector(
  standardPriceSelector,
  standardPriceImmutable => {
    const standardPrice = standardPriceImmutable.toJS()
    return ({
      redirect: (standardPrice.standardPriceCreate.redirect
      || standardPrice.standardPriceEdit.redirect
      || standardPrice.standardPriceGet.redirect
      || standardPrice.standardPriceDeactivate.redirect
      || standardPrice.standardPriceList.redirect
      || standardPrice.standardPriceExport.redirect),
      isAuthenticated: (standardPrice.standardPriceCreate.isAuthenticated
      || standardPrice.standardPriceEdit.isAuthenticated
      || standardPrice.standardPriceGet.isAuthenticated
      || standardPrice.standardPriceDeactivate.isAuthenticated
      || standardPrice.standardPriceList.isAuthenticated
      || standardPrice.standardPriceExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/standard-price/standard-price-selector.js